import { Identifiable, Project, ProjectExternalLink } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function extractList(data: { [key: string]: string }): {
  [key: string]: ProjectExternalLink;
} {
  return JSON.parse(data.externalLinks || "{}");
}

function editLink(
  link: ProjectExternalLink,
  nextLink: ProjectExternalLink,
  list: {
    [key: string]: ProjectExternalLink;
  },
) {
  return JSON.stringify({
    ...list,
    [link.index]: nextLink,
  });
}

function editProjectExternalLink(httpClient: HttpClient) {
  return (
    { uuid }: Identifiable<Project>,
    link: ProjectExternalLink,
    nextLink: ProjectExternalLink,
  ) =>
    httpClient
      .sendHttpRequest<Identifiable<Project>>({
        endpoint: `/projects/${uuid}`,
        method: HttpMethods.GET,
      })
      .then((project) =>
        httpClient.sendHttpRequest<void>({
          endpoint: `/projects/${project.uuid}`,
          method: HttpMethods.PATCH,
          data: {
            data: {
              externalLinks: editLink(
                link,
                nextLink,
                extractList(project.data),
              ),
            },
          },
        }),
      );
}

export { editProjectExternalLink };
